import { isStoredNicknamePatternValid } from '@utils/nickname';

export type ProfilePathParams = {
  userId?: number | null;
  nickname?: string | null;
};

export const buildProfilePath = (params: ProfilePathParams): string | null => {
  const nickname = (params.nickname ?? '').trim();
  if (isStoredNicknamePatternValid(nickname)) {
    return `/@${nickname}`;
  }

  const userId = params.userId;
  if (typeof userId === 'number' && Number.isFinite(userId) && userId > 0) {
    return `/people/${userId}`;
  }

  return null;
};
